import React, { Fragment } from 'react';
import styled from '@emotion/styled';

import { Flex } from 'common/components/Flex';
import UnderlinedButton from 'common/components/Reclamation/UnderlinedButton';
import { HeadlineH8 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import { focusOutlineCSSWithOffsetAndRadius } from 'common/theme/styles';
import EditButton from '../EditButton';
import Separator from '../Separator';
import CommentValue from './CommentValue';

interface AddEditCommentProps {
  value: string;
  isDisabled: boolean;
  onEdit: () => void;
}

const StyledUnderlinedButton = styled(UnderlinedButton)`
  ${focusOutlineCSSWithOffsetAndRadius};
`;

const AddEditComment = ({ value, isDisabled, onEdit }: AddEditCommentProps) => {
  const { r, t } = useLocalization();

  return (
    <Fragment>
      <Separator />
      {value === '' ? (
        <StyledUnderlinedButton
          disabled={isDisabled}
          data-testid="add-comment-button"
          onClick={onEdit}
        >
          {t('h24_add_comment')}
        </StyledUnderlinedButton>
      ) : (
        <Flex justifyContent="space-between" alignItems="flex-start">
          <Flex flexDirection="column">
            <HeadlineH8 as="h2">{t('h24_comment')}</HeadlineH8>
            <CommentValue data-testid="comment">{value}</CommentValue>
          </Flex>
          <EditButton
            dataTestId="edit-comment-button"
            ariaLabel={r.t('h24_edit_comment', {
              comment: value,
            })}
            isDisabled={isDisabled}
            onClick={onEdit}
          />
        </Flex>
      )}
    </Fragment>
  );
};

export default AddEditComment;
